module.exports = __webpack_public_path__ + "img/test-desk.11abe49f.png";